import styled from 'styled-components';

export const NotificationsPermissionWrapper = styled.div`
  display: block;
  height: 100%;
`;

export const ModalImage = styled.img`
  width: 100%;
  height: 100%;
`;

export const ButtonsContainer = styled.div`
  width: 100%;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  position: absolute;
  bottom: 10%;
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  justify-content: center;
  display: ${({ imageSource }) => (imageSource ? 'flex' : 'none')};
`;

export const ButtonText = {
  fontWeight: '900',
};

export const RowWrapperLink = {
  position: 'absolute',
  bottom: '17%',
  paddingInline: '22%',
};

export const FacebookLinkButton = {
  width: 200,
  height: 35,
};

export const MemberLinkButton = {
  width: 200,
  height: 37,
  margin: 0,
};

